import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./broadcastConfirmModal.module.css";
import venchyImg from "../../../images/questionnaire_doctor.png";

interface BroadcastConfirmModalProps {
  onConfirmAll: () => void;
  onConfirmCurrent: () => void;
  onClose: () => void;
}

function BroadcastConfirmModal({
  onConfirmAll,
  onConfirmCurrent,
  onClose,
}: BroadcastConfirmModalProps) {
  return (
    <article className={popupStyles.popup} data-testid="broadcast-confirm-popup">
      <img className={popupStyles.popup__img} src={venchyImg} alt={t("VENCHI")} />
      <h2 className={popupStyles.popup__title}>{t("CONFIRM_BROADCAST_TITLE")}</h2>
      <p className={popupStyles.popup__text}>{t("CONFIRM_BROADCAST_MESSAGE")}</p>
      <div className={popupStyles.popup__buttons}>
        <button
          className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btnPrimary} hover`}
          data-testid="broadcast-all-button"
          onClick={() => {
            onConfirmAll();
          }}
        >
          {t("SEND_TO_ALL_COMPANIES")}
        </button>
        <button
          className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btnSecondary} hover`}
          data-testid="broadcast-current-button"
          onClick={() => {
            onConfirmCurrent();
          }}
        >
          {t("SEND_TO_CURRENT_COMPANY")}
        </button>
      </div>
    </article>
  );
}

export default BroadcastConfirmModal;
